import { createLogic } from 'redux-logic'
import * as constants from '../constants'
import { map } from 'rxjs/operators'

export const getListInfo = createLogic({
  type: constants.GET_LIST_INFO.ACTION,
  processOptions: {
    successType: constants.GET_LIST_INFO.FULFILLED,
    failType: constants.GET_LIST_INFO.REJECTED
  },
  process({ http, action }) {

    return http
      .post('/api/common/compsList/getListDetails', { ...action.payload })
      .pipe(map(http.getBody))
  }
})
